"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentsSeriesPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var i18n_1 = __importDefault(require("../i18n"));
var TitleHelmet_1 = require("./TitleHelmet");
var useFirstGetContents_1 = require("../effects/useFirstGetContents");
var TwitterWidget_1 = require("./TwitterWidget");
var User_1 = require("./User");
var api_1 = require("../api");
var util_1 = require("../util");
var sentry_1 = require("../sentry");
exports.ContentsSeriesPage = (0, react_router_1.withRouter)(function (state) {
    var id = state.match.params.id;
    var contentsSeries = state.contentsSeriesList.filter(function (_contentsSeries) { return _contentsSeries.id === id; })[0];
    var contentsItems = (0, react_1.useMemo)(function () { return state.contentsItems.filter(function (contentsItem) { return contentsItem.contentsSeriesId === id; }); }, [
        state.contentsItems
            .map(function (contentsItem) { return "[".concat(contentsItem.id, " ").concat(contentsItem.contentsSeriesId, " ").concat(contentsItem.content, "]"); })
            .join(""),
    ]);
    var _a = (0, react_1.useReducer)(function (prev) { return prev + 1; }, 0), reloadTweet = _a[0], incrReloadTweet = _a[1];
    (0, react_1.useEffect)(function () {
        twttr.widgets.load();
    }, [contentsItems, reloadTweet]);
    var _b = (0, react_1.useState)(undefined), user = _b[0], setUser = _b[1];
    (0, react_1.useEffect)(function () {
        if (user === undefined && contentsSeries)
            loadUser(contentsSeries.userProfileId, setUser);
    }, [contentsSeries]);
    (0, useFirstGetContents_1.useFirstGetContents)(state);
    var loading = state.contentsSeriesLoading || state.contentsItemsLoading;
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: loading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: loading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), (0, jsx_runtime_1.jsx)(TitleHelmet_1.TitleHelmet, { title: contentsSeries ? contentsSeries.name : undefined }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/contents", children: i18n_1.default.back }) }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { onClick: function () { return incrReloadTweet(); }, children: "Reload Tweets" }) }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { columns: "1", children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: contentsSeries ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Header, { as: "h2", textAlign: "center", children: [contentsSeries.name, contentsSeries.description && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Header.Subheader, { children: contentsSeries.description })), contentsSeries.userProfileId === state.selfUser.id && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Header.Subheader, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/contents_series/".concat(contentsSeries.id, "/edit"), children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { children: i18n_1.default.edit }) }) }))] }), user && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Popup, { trigger: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Label, { children: ["by ", user.displayName] }), content: (0, jsx_runtime_1.jsx)(User_1.User, { compactView: true, user: user, world: false }) }))] })) : (i18n_1.default.noContents) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: contentsItems.map(function (contentsItem) { return ((0, jsx_runtime_1.jsx)(TwitterWidget_1.TwitterWidget, { url: contentsItem.content }, contentsItem.id)); }) })] })] }));
});
var loadUser = function (id, setUser) { return __awaiter(void 0, void 0, void 0, function () {
    var user, profile, userModel, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, (0, api_1.fetchUserById)(id)];
            case 1:
                user = _a.sent();
                return [4 /*yield*/, (0, api_1.fetchProfile)(id)];
            case 2:
                profile = _a.sent();
                if (!user || !profile)
                    return [2 /*return*/];
                if (user) {
                    userModel = __assign(__assign({}, user), { profile: profile, locationInfo: (0, util_1.parseUserLocation)(user) });
                    setUser(userModel);
                }
                else {
                    setUser(null);
                }
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                (0, sentry_1.captureException)(e_1);
                alert(e_1);
                setUser(null);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
